import React from "react";

/**
 * TableTypeDate component - visually shows a formatted date string but preserves timestamp for sorting
 * @param props - The React props containing children (timestamp)
 * @returns {JSX.Element} - A formatted date string
 */
const TableTypeDate = (props) => {
    // Helper function to format date from timestamp
    function formatDate(value) {
        // Try to ensure we have a valid date object
        let dateObj;
        
        if (value instanceof Date) {
            dateObj = value;
        } else if (typeof value === 'number') {
            // Handle timestamp in milliseconds
            dateObj = new Date(value);
        } else if (typeof value === 'string') {
            // Try to parse string as date
            dateObj = new Date(value);
        } else {
            return '';
        }
        
        // Check if date is valid
        if (isNaN(dateObj.getTime())) {
            return '';
        }
        
        // Format to DD/MM/YYYY
        return ('0' + dateObj.getDate()).slice(-2) + '/'
            + ('0' + (dateObj.getMonth()+1)).slice(-2) + '/'
            + dateObj.getFullYear();
    }
    
    // Get the raw value from props.children
    const rawValue = props.children;
    
    // For sorting, extract the timestamp value (Date.getTime())
    let timestamp = 0;
    let formattedDate = '';
    
    if (rawValue instanceof Date) {
        timestamp = rawValue.getTime();
        formattedDate = formatDate(rawValue);
    } else if (typeof rawValue === 'number') {
        timestamp = rawValue;
        formattedDate = formatDate(rawValue);
    } else if (typeof rawValue === 'string') {
        // Try to parse string as date for sorting
        const dateObj = new Date(rawValue);
        if (!isNaN(dateObj.getTime())) {
            timestamp = dateObj.getTime();
            formattedDate = formatDate(dateObj);
        } else {
            // It's a string that's not a date
            formattedDate = rawValue;
        }
    } else if (rawValue && typeof rawValue === 'object') {
        formattedDate = String(rawValue);
    }
    
    return (
        <p className="my-auto" data-timestamp={timestamp}>
            {formattedDate}
        </p>
    );
}

export default TableTypeDate;